import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { AboutSection } from "@/components/AboutSection";
import { MaldivesTeaser } from "@/components/MaldivesTeaser";
import { ProgramsTeaser } from "@/components/ProgramsTeaser";
import { ReviewsSection } from "@/components/ReviewsSection";
import { FeaturedOffers } from "@/components/FeaturedOffers";
import { HotelsTeaser } from "@/components/HotelsTeaser";
import { ContactSection } from "@/components/ContactSection";
import { LocationSection } from "@/components/LocationSection";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/lib/pageMeta";
import { HOTELS_SECTION_ENABLED } from "@/lib/sectionFlags";
import { siteUrl } from "@/lib/site";
import { scrollToSection, scrollToTop } from "@/lib/lenis";

export default function HomePage() {
  usePageMeta("دليل المسافر للحجوزات | وكالة سفر في السيف، البحرين", siteUrl("/"), "وكالة سفر في منطقة السيف بالبحرين: برامج سياحية مقترحة، دليل منتجعات المالديف، وطلب تصميم رحلة عبر واتساب.");

  // تمرير إلى قسم مطلوب عبر الهاش (#about …): يعمل عند الفتح المباشر، والقدوم من صفحات
  // أخرى، والرجوع/التقدم في المتصفح. يعيد المحاولة حتى تكتمل عناصر الصفحة، ثم يثبّت
  // الموضع بإعادات لاحقة لأن تحميل الصور يزيح التخطيط بعد أول تمرير.
  const { hash } = useLocation();
  useEffect(() => {
    if (!hash) return undefined;
    let cancelled = false;
    const timers = [];
    const settle = () => {
      [700, 1800].forEach((ms) => timers.push(window.setTimeout(() => { if (!cancelled) scrollToSection(hash); }, ms)));
    };
    const tryScroll = (attempt) => {
      if (cancelled) return;
      if (document.querySelector(hash)) { scrollToSection(hash); settle(); return; }
      if (attempt < 25) timers.push(window.setTimeout(() => tryScroll(attempt + 1), 160));
    };
    timers.push(window.setTimeout(() => tryScroll(0), 120));
    return () => { cancelled = true; timers.forEach((t) => window.clearTimeout(t)); };
  }, [hash]);

  // الرجوع/التقدم إلى «/» بلا هاش يعيد أعلى الصفحة
  useEffect(() => {
    const onPop = () => { if (!window.location.hash) scrollToTop(true); };
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  return (
    <div className="bg-[#FFFFFF] min-h-screen">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <AboutSection />
        <MaldivesTeaser />
        <FeaturedOffers />
        {HOTELS_SECTION_ENABLED && <HotelsTeaser />}
        <ProgramsTeaser />
        <ReviewsSection />
        <ContactSection />
        <LocationSection />
      </main>
      <Footer />
    </div>
  );
}
